import { Stack, Typography } from "@mui/material";
import { convertISODateTime } from "@entrilia/shared/utilities/dateUtils";
import { workflowTypeCaptionMap } from "@entrilia/shared/utilities/enumCaptions";
import type { InvestorChangeRequestDetails } from "../../../../api/types/workflowTypes";
import WorkflowStatusTag from "../WorkflowStatusTag";

interface Props {
  changeRequestDetails: InvestorChangeRequestDetails;
}

const ChangeRequestDetailsTitle = ({ changeRequestDetails }: Props) => {
  return (
    <Stack spacing={0.5} sx={{ py: 1.5 }}>
      <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
        {changeRequestDetails.referenceCode && (
          <Typography variant="h6">{"# " + changeRequestDetails.referenceCode}</Typography>
        )}
        {changeRequestDetails.referenceCode && <Typography variant="h6">&bull;</Typography>}
        <Typography variant="h6">{changeRequestDetails.investorName}</Typography>
        <WorkflowStatusTag workflowStatus={changeRequestDetails.workflowStatus} />
      </Stack>
      <Stack direction="row" spacing={1}>
        <Typography variant="caption">
          {workflowTypeCaptionMap[changeRequestDetails.workflowType] ?? changeRequestDetails.workflowType}
        </Typography>
        <Typography variant="caption">&bull;</Typography>
        <Typography variant="caption">{convertISODateTime(changeRequestDetails.requestedAt)}</Typography>
      </Stack>
    </Stack>
  );
};

export default ChangeRequestDetailsTitle;
